import { createTheme as CreateTheme } from "@mui/material"

export function createTheme(setting: any){
    return CreateTheme({
    palette: {
        mode: setting && setting === 'dark' ? 'dark' : 'light',
      },
    });
}